import React from "react";
import { useTranslation } from "react-i18next";
import "./ecommerce.css";
import Header from "../../../components/header/header";
import Footer from "../../../components/footer/footer";
import BannerComponent from "../../../components/bannerComponent/bannerComponent";
import BenefitsCardsComponent from "../../../components/benefitsCardsComponent/benefitsCardsComponent";
import ButtonLinkComponent from "../../../components/buttonLink/buttonLink.jsx";

const ECommerce_MoreServices = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=ECOMMERCE";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("MORE_SERVICE_ECOMMERCE_SUBTITLE"),
    text: t("MORE_SERVICE_ECOMMERCE_DESCRIPTION"),
    className: "ecommerceHeroBanner",
    chipText: "E-Commerce",
  };

  const cardBenefitsData = [
    {
      title: t("MORE_SERVICE_ECOMMERCE_CUSTOM_CATALOGS"),
      text: t("MORE_SERVICE_ECOMMERCE_CUSTOM_CATALOGS_DESC"),
      icon: "custom_catalogs.svg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_AUTOMATED_ORDERING"),
      text: t("MORE_SERVICE_ECOMMERCE_AUTOMATED_ORDERING_DESC"),
      icon: "automated_ordering.svg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_INVENTORY_MANAGEMENT"),
      text: t("MORE_SERVICE_ECOMMERCE_INVENTORY_MANAGEMENT_DESC"),
      icon: "inventory_management.svg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_FLEXIBLE_PAYMENT_OPTIONS"),
      text: t("MORE_SERVICE_ECOMMERCE_FLEXIBLE_PAYMENT_OPTIONS_DESC"),
      icon: "flexible_payment_options.svg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_ANALYTICS_REPORTING"),
      text: t("MORE_SERVICE_ECOMMERCE_ANALYTICS_REPORTING_DESC"),
      icon: "analytics_reporting.svg",
    },
  ];

  const processData = [
    {
      title: t("MORE_SERVICE_ECOMMERCE_CONSULTATION"),
      text: t("MORE_SERVICE_ECOMMERCE_CONSULTATION_DESC"),
      img: "/img/DreamShaper_v7_virtual_assistant_that_help_the_companies_to_in_3 3.jpg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_SOLUTION_DESIGN"),
      text: t("MORE_SERVICE_ECOMMERCE_SOLUTION_DESIGN_DESC"),
      img: "/img/young-adult-programmer-typing-computer-office-generated-by-ai 3.jpg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_SEAMLESS_INTEGRATION"),
      text: t("MORE_SERVICE_ECOMMERCE_SEAMLESS_INTEGRATION_DESC"),
      img: "/img/contact us 1.jpg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_STAFF_TRAINING"),
      text: t("MORE_SERVICE_ECOMMERCE_STAFF_TRAINING_DESC"),
      img: "/img/DreamShaper_v7_Robot_doing_repetitive_tasks_on_a_computer_serv_3 3.jpg",
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_LAUNCH_SUPPORT"),
      text: t("MORE_SERVICE_ECOMMERCE_LAUNCH_SUPPORT_DESC"),
      img: "/img/view-people-addicted-their-smartphone-looking-scrolling-through-screens 1.jpg",
    },
  ];

  const keyData = [
    {
      title: t("MORE_SERVICE_ECOMMERCE_SIMPLIFIED_BULK_ORDERING"),
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_EFFICIENT_INVENTORY_MANAGEMENT"),
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_SEAMLESS_TRANSACTIONS"),
    },
    {
      title: t("MORE_SERVICE_ECOMMERCE_ENHANCED_CUSTOMER_EXPERIENCE"),
    },
  ];

  function ProcessCard({ img, title, text, step }) {
    return (
      <article className="ecommerceProcessCard">
        <div className="ecommerceProcessMedia">
          <img src={img} alt={title} />
        </div>

        <div className="ecommerceProcessContent">
          <div className="ecommerceStepNumber">{step}</div>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </article>
    );
  }

  function BenefitCard({ text }) {
    return (
      <article className="ecommerceBenefitCard">
        <p>{text}</p>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="ecommercePage">
        <section className="ecommerceHero ecommerceHeroFull">
          <div className="ecommerceHeroBannerFull">
            <BannerComponent
              translateTitle={heroData.title}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("MORE_SERVICE_ECOMMERCE_CTA")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="ecommerceFeatures">
          <div className="ecommerceFeaturesWrap">
            <div className="ecommerceSectionIntro">
              <h2>{t("MORE_SERVICE_ECOMMERCE_KEY_FEATURES_TITLE")}</h2>
              <p>{t("MORE_SERVICE_ECOMMERCE_KEY_FEATURES_DESC")}</p>
            </div>

            <BenefitsCardsComponent title="" cardsData={cardBenefitsData} />
          </div>
        </section>

        <section className="ecommerceProcess">
          <div className="ecommerceSectionIntro">
            <h2>{t("MORE_SERVICE_ECOMMERCE_PROCESS_TITLE")}</h2>
            <p>{t("MORE_SERVICE_ECOMMERCE_PROCESS_DESC")}</p>
          </div>

          <div className="ecommerceProcessTimeline">
            <div className="ecommerceProcessGrid">
              {processData.map((process, index) => (
                <ProcessCard
                  key={index}
                  step={index + 1}
                  title={process.title}
                  text={process.text}
                  img={process.img}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="ecommerceBenefits">
          <div className="ecommerceBenefitsWrap">
            <div className="ecommerceSectionIntro">
              <h2>{t("MORE_SERVICE_ECOMMERCE_BENEFITS_TITLE")}</h2>
              <p>{t("MORE_SERVICE_ECOMMERCE_BENEFITS_DESC")}</p>
            </div>

            <div className="ecommerceBenefitsGrid">
              {keyData.map((benefit, index) => (
                <BenefitCard key={index} text={benefit.title} />
              ))}
            </div>
          </div>
        </section>

        <section className="ecommerceCta">
          <div className="ecommerceCtaInner">
            <div className="ecommerceCtaContent">
              <h2>{t("MORE_SERVICE_ECOMMERCE_FINAL_TITLE")}</h2>
              <div className="ecommerceCtaText">
                <p>{t("MORE_SERVICE_ECOMMERCE_FINAL_DESC")}</p>
              </div>
            </div>

            <ButtonLinkComponent
              translateButton={t("MORE_SERVICE_ECOMMERCE_CTA")}
              url="https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=ECOMMERCE"
              blank={true}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default ECommerce_MoreServices;